// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ImportWorkspaceSchema = z.object({
  id: z.number().int().describe("Unique identifier for the workspace in the external system"),
  name: z.coerce.string().describe("Name of the workspace"),
});
